import { uniqBy } from 'lodash-es';

import { SafelistTerm } from 'shared/types/safelist';

/**
 * Filters the duplicated safelist terms from the array using the provided key.
 */
export const filterRepeatedTerms = (terms: SafelistTerm[], key = 'entity') => (
  uniqBy(terms, key)
);
